export const SET_GOOD_LUCK_MESSAGES = 'SET_GOOD_LUCK_MESSAGES';
export const SET_PRODUCTS = "SET_PRODUCTS";